// eslint-disable-next-line import/prefer-default-export
export const Colors = Object.freeze({
  white: '#ffffff',
  primary: '#297DAE',
  success: '#31814C',
  warning: '#ff873e',
  error: '#BF3C3C',
  tierTwoNavBackground: '#3E4751',
  text: '#4d5965',
  warningAlertText: '#f5a623',
  lightGray: '#f1f1f1',
  principalPrimary: '#035fa4',
});
